'use client';

import { Grid, List, type SxProps } from '@coolblue-development/freddy';
import { Flex, FlexProps } from '@coolblue-development/freddy';
import styled from '@emotion/styled';

// This component is extracted because we cannot pass a theme function to the sx prop
// of a component used directly in a server component, in this case, the page component.
// Importing this component into the page fixes works around this RSC caveat.
export const BetterOptionRows = ({ children }: { children: React.ReactNode }) => (
  <Grid
    templateColumns='1fr'
    mt={400}
    sx={{ ul: { listStyle: 'none', padding: 0, margin: '0', width: '100%' } }}
  >
    <List
      marker='none'
      sx={theme => ({
        li: { margin: '0 !important', width: '100%' },
        '& > li:last-of-type li:first-of-type': {
          borderRadius: `0 0 ${theme.borderRadius[100]} ${theme.borderRadius[100]}`
        }
      })}
    >
      {children}
    </List>
  </Grid>
);

export const stickyTitleStyles: SxProps = { position: 'sticky', left: '0' };

export const BetterOptionsBlockContainer = styled(Flex)<FlexProps & { id?: string }>(
  ({ theme }) => ({
    overflow: 'auto',

    [theme.breakpoint.maxWidth('lg')]: {
      margin: `0 calc(-1 * var(--cb-spec-container-horizontal-padding))`,
      padding: `0 var(--cb-spec-container-horizontal-padding)`
    }
  })
);
